import * as React from "react";

import { components, OptionProps, GroupTypeBase } from "react-select";
import Axios from "axios";
import { Avatar } from "components/avatar";
import Select from "components/react-select";

type Options = {
  value: number;
  label: string;
};

export type Assignees = {
  id: number;
  first_name: string;
  last_name: string;
};

type AssigneeOption = { value: number | string; label: string };

/** Preserve parent value order; only enrich labels from loaded options. */
function valueInSelectionOrder(
  value: AssigneeOption[] | null | undefined,
  options: Options[]
): Options[] {
  const selected = Array.isArray(value) ? value : [];
  if (!selected.length) return [];
  if (!options.length) return selected as Options[];

  const byId = new Map(options.map((opt) => [String(opt.value), opt]));
  return selected.map((item) => {
    const match = byId.get(String(item.value));
    if (!match) return item as Options;
    return {
      value: match.value,
      label: item.label || match.label,
    };
  });
}

export default function Assignee(props: any) {
  const [assigneeOption, setAssigneeOption] = React.useState<Options[] | []>(
    []
  );

  const isMulti = props.isMulti !== false;

  const orderedValue = React.useMemo(() => {
    if (!isMulti) {
      return props.value ?? null;
    }
    return valueInSelectionOrder(props.value, assigneeOption);
  }, [isMulti, props.value, assigneeOption]);

  React.useEffect(() => {
    const fetchAssignee = async () => {
      try {
        let target = "all";

        if (props.assigneeType === "appointment") {
          target = "assignableToAppointments";
        }

        const employee = await Axios.get(`
              ${process.env.REACT_APP_SERVER_URL}/api/v1/company/employee/${target}
              `);
        setAssigneeOption(
          employee.data.map(({ id, first_name, last_name }: Assignees) => ({
            value: id,
            label: first_name + " " + last_name,
          }))
        );
      } catch (e) {
        console.error(e);
      }
    };

    fetchAssignee();
  }, []);

  const { value: _value, onChange, isMulti: _isMulti, ...selectProps } = props;

  return (
    <Select
      components={{ Option }}
      options={assigneeOption}
      isMulti={isMulti}
      {...selectProps}
      value={orderedValue}
      onChange={(newValue: unknown) => {
        if (onChange) {
          onChange(newValue);
        }
      }}
    />
  );
}

const Option = ({
  children,
  ...props
}: OptionProps<Options, true, GroupTypeBase<Options>>) =>(
  <components.Option {...props}>
    <div>
      <Avatar showLabel size="xsmall" user_id={props.data.value}>
        {children}
      </Avatar>
    </div>
  </components.Option>
);
